import type { SelectOption } from '@diamond/shared/types';

/**
 * Plant options for Collection Management filter
 */
export const PLANT_OPTIONS: SelectOption[] = [
  { label: 'Semua', value: 'all' },
  { label: 'Irian', value: 'irian' },
  { label: 'Halma', value: 'halma' },
  { label: 'Ancol', value: 'ancol' },
];

/**
 * Distribution Channel options for Collection Management filter
 */
export const CABANG_OPTIONS: SelectOption[] = [
  { label: 'Pekanbaru', value: 'DP' },
  { label: 'Jakarta', value: 'DA' },
  { label: 'Cimahi', value: 'DF' },
  { label: 'Surabaya', value: 'DR' },
  { label: 'Medan', value: 'DM' },
  { label: 'Yogyakarta', value: 'DS' },
  { label: 'Makasar', value: 'DK' },
  { label: 'Denpasar', value: 'DH' },
  { label: 'Lombok', value: 'DJ' },
  { label: 'Balikpapan', value: 'DC' },
  { label: 'Semarang', value: 'DQ' },
  { label: 'Manado', value: 'DL' },
  { label: 'Batam', value: 'DE' },
  { label: 'Banjarmasin', value: 'DD' },
  { label: 'Palembang', value: 'DO' },
  { label: 'Lampung', value: 'DI' },
  { label: 'Cirebon', value: 'DG' },
  { label: 'Padang', value: 'DN' },
  { label: 'Malang', value: 'DU' },
  { label: 'Pontianak', value: 'DV' },
];
